import React from 'react';
import 'bootstrap/dist/css/bootstrap.rtl.min.css';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { BrowserView, MobileView, } from 'react-device-detect';
import NavbarOrLogin from './components/layout/NavbarOrLogin';
import Customers from './components/customers/Customers';
import Managers from './components/managers/Managers';
import Orders from './components/orders/Orders';
import Products from './components/products/Products';
import NotNeeded from './components/orders/NotNeeded';
import Order from './components/orders/Order';
import Payment from './components/orders/Payment';
import PaymentMessage from './components/orders/PaymentMessage';
import Register from './components/auth/Register';
import Login from './components/auth/Login';
import Alerts from './components/layout/Alerts'
import setAuthToken from './utils/setAuthToken';
import PrivateRoute from './components/routing/PrivateRoute';
import CustomersState from './context/customers/CustomersState';
import ManagersState from './context/managers/ManagersState';
import AuthState from './context/auth/AuthState';
import OrdersState from './context/orders/OrdersState';
import ProductsState from './context/products/ProductsState';
import AlertState from './context/alert/AlertState';
import BottomNav from './components/layout/bottomNav'
import Container from 'react-bootstrap/Container';

import './App.css';
import './App.scss';
import './Rachel.css';
import './Miriam.css';
if (localStorage.token) {
  setAuthToken(localStorage.token);
}

const App = () => {
  const isInIframe = window.self !== window.top;

  return (
    <AuthState>
      <CustomersState>
        <ManagersState>
        <ProductsState>
          <OrdersState>
            <AlertState>
              <Router>
                <div>
                  <BrowserView>
                    {!isInIframe && <NavbarOrLogin />}
                    <Container fluid>

                      <Alerts />
                      <Routes>
                        <Route exact path='/not_needed/:id' element={<PrivateRoute element={<NotNeeded />} />} />
                        <Route exact path='/' element={<PrivateRoute element={<Orders />} />} />
                        <Route exact path='/customers' element={<PrivateRoute element={<Customers />} />} />
                        <Route exact path='/managers' element={<PrivateRoute element={<Managers />} />} />
                        <Route exact path='/orders' element={<PrivateRoute element={<Orders />} />} />
                        <Route exact path='/products' element={<PrivateRoute element={<Products />} />} />
                        <Route  exact path='/orders/:id' element={<PrivateRoute   element={<Order />} />} />
                        <Route  exact path='/payment/' element={<PrivateRoute   element={<Payment />} />} />
                        <Route  exact path='/payment-message/' element={<PrivateRoute   element={<PaymentMessage />} />} />
                        <Route exact path='/register' element={<Register />} />
                        <Route exact path='/login' element={<Login />} />
                      </Routes>

                    </Container>
                    
                  </BrowserView>
                  <MobileView>
                  {!isInIframe && <NavbarOrLogin />}
                    <Container fluid className='mobile_container'>
                      <Alerts />
                      <Routes>
                        <Route exact path='/not_needed/:id' element={<PrivateRoute element={<NotNeeded />} />} />
                        <Route exact path='/login' element={<Login />} />
                        <Route exact path="/" element={<PrivateRoute element={<Orders />} />} />
                        <Route exact path="/orders" element={<PrivateRoute element={<Orders />} />} />
                        <Route exact path="/orders/:id" element={<PrivateRoute element={<Orders />} />} />

                        <Route exact path="/cart/:id" element={<PrivateRoute element={<Order />} />} />
                        <Route  exact path='/payment-message/' element={<PrivateRoute   element={<PaymentMessage />} />} />
                      </Routes>
                      {!isInIframe && <BottomNav />}
                    </Container>
                    {/* <BottomNav/> */}
                  </MobileView>
                </div>
              </Router>
            </AlertState>
          </OrdersState>
        </ProductsState>
        </ManagersState>
      </CustomersState>
    </AuthState>
  );
}

export default App;
